import http, { ResponseData } from './httpService'
import { IsaacComplainDetailRes } from '../typings/complainTypes'

export const getComplainDetail = async (
  phone: string,
  idCard: string,
  smsCode: string
): Promise<IsaacComplainDetailRes[]> => {
  const { data } = await http.get<ResponseData<IsaacComplainDetailRes[]>>('/fe/complain/detail', {
    params: { phone, idCard, smsCode },
  })
  return data.data
}
